import React , {createContext} from 'react';
export const LoginContexts = createContext();